export default function validatePasswordLength(value) {
  return typeof value === 'string' && value.length >= 6
}



// WEBPACK FOOTER //
// ./src/alelo-logic/utils/validatePasswordLength.js